<template lang="pug">
  .noauth
    p.noauth__heading {{ componentTitle }}
    .noauth__links
      template(v-if="isSingleButton")
        component.noauth__link(
          :is="getElemTag"
          @click="singleButtonHandler"
          :class="buttonClasses")
          span {{ singleButtonTitle }}

      template(v-else)
        component.noauth__link(
          :is="getElemTag"
          @click="showSignin"
          :class="buttonClasses")
          span {{ $t('auth.login') }}
        span.noauth__separator(v-if="isSeparator") &nbsp;|&nbsp;
        component.noauth__link(
          :is="getElemTag"
          @click="showSignup"
          :class="buttonClasses")
          span {{ $t('auth.register') }}

</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("global");

export default {
  name: "NoAuth",
  props: {
    isButton: Boolean,
    buttonClasses: String,
    noAuthTitle: {
      type: String,
    },
    isSeparator: {
      type: Boolean,
      default: true,
    },
    isSingleButton: {
      type: Boolean,
      default: false,
    },
    singleButtonName: {
      type: String,
    },
    singleButtonAction: {
      type: String,
      default: "signup",
    },
  },
  computed: {
    ...mapGetters(["isUserNotAuthed", "isUserInProject", "isUserAuthedNotRegistered"]),
    getElemTag() {
      return this.isButton ? "button" : "div";
    },
    componentTitle() {
      return this.noAuthTitle || this.$t("auth.noauth");
    },
    singleButtonTitle() {
      return this.singleButtonName || this.$t("auth.login");
    },
  },

  methods: {
    showSignup() {
      if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      } else {
        this.$authService.showSignup();
      }
    },
    showSignin() {
      if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      } else {
        this.$authService.showSignin();
      }
    },
    singleButtonHandler() {
      if (this.singleButtonAction === "signup") {
        this.showSignup();
      } else {
        this.showSignin();
      }
    },
  },
};
</script>
